import toast from "react-hot-toast";

/**
 * Toast notification utilities
 */

export const showSuccess = (message: string) => {
    toast.success(message, {
        duration: 3000,
        position: "top-right",
    });
};

export const showError = (message: string, details?: string) => {
    toast.error(details ? `${message}: ${details}` : message, {
        duration: 5000,
        position: "top-right",
    });
};

export const showInfo = (message: string) => {
    toast(message, {
        duration: 3000,
        position: "top-right",
        icon: "ℹ️",
    });
};

export const showWarning = (message: string) => {
    toast(message, {
        duration: 4000,
        position: "top-right",
        icon: "⚠️",
    });
};

/**
 * Confirm dialog using toast with custom confirmation
 * Returns a promise that resolves to true if confirmed
 */
export const confirmAction = (message: string): Promise<boolean> => {
    return new Promise((resolve) => {
        const confirmed = window.confirm(message);
        resolve(confirmed);
    });
};